import { createSlice } from "@reduxjs/toolkit";
import services from "../../API/services";

export const initialState = {
  propertyCount: 0,
  rRoomProperty: [],
  searchVal: "",
  loading: true,
  filterValues: {
    propertyCategoryFilter: [],
    roomCategoryFilter: [],
    travellerChoice: [],
    localityFilter: [],
    latlongFilter: { lat: null, long: null },
    cityId: 0,
  },
};

const propertySlice = createSlice({
  name: "Property",
  initialState,
  reducers: {
    clearPropertyState: () => initialState,
    // getRroomProperty: (state, { payload }) => {
    //   state.rRoomProperty = payload;
    // },
    getRroomProperty: (state, { payload }) => {
      // state.rRoomProperty = [...state.rRoomProperty, ...payload]; 
      const { data, page } = payload; 

    if (page === 1) {
        state.rRoomProperty = data; 
    } else {
        state.rRoomProperty = [...state.rRoomProperty, ...data];
    }
    },
    setFilter: (state, { payload }) => {
      state.filterValues = { ...state.filterValues, ...payload };
    },
    setSearch: (state, { payload }) => {
      state.searchVal = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setHasMore: (state, { payload }) => {
      state.hasMore = payload; 
    },
    setPropertyCount: (state, { payload }) => {
      state.propertyCount = payload; 
    },
  },
});

export const {
  clearPropertyState,
  getRroomProperty,
  setFilter,
  setSearch,
  clearFilter,
  setLoading,
  setHasMore,
  setPropertyCount
} = propertySlice.actions;

// Action creators are generated for each case reducer function
export const propertySeletor = (state) => state.propertys;

export default propertySlice.reducer;

export const getRroomPropertyAction = (params, page = 1) => {
  return async (dispatch) => {
    dispatch(setLoading(true));

    try {
      const res = await services.property.searchPropertyServiceGet(params);

      if (res.status === 200) {
        const newData = res?.data?.data || [];
        dispatch(setPropertyCount(res?.data?.count))
        dispatch(getRroomProperty({ data: newData, page }));
        dispatch(setHasMore(newData.length > 0));
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setHasMore(false));
    }

    dispatch(setLoading(false));
  };
};


// export const getRroomPropertyAction = (params) => {
//   return async (dispatch) => {
//     dispatch(setLoading(true));
//     try {
//       const res = await services.property.searchPropertyServiceGet(params);
//       if (res.status === 200) {
//         await dispatch(setLoading(false));
//         await dispatch(getRroomProperty(res?.data?.data));
//       }
//     } catch (error) {
//       dispatch(setLoading(false));
//     }
//   };
// };
